import { render, staticRenderFns } from "./IconCircleAlert.vue?vue&type=template&id=3e5fc98e"
import script from "./IconCircleAlert.vue?vue&type=script&lang=js"
export * from "./IconCircleAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports